import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';
import { RoutePrivateProps } from 'components/Route/Private/types';

const TaxonomyForm = React.lazy(() => import('components/Taxonomy/Form/Form'));

function ScreensTaxonomyForm(params: Readonly<RoutePrivateProps>) {
  const id = params.id ? parseInt(params.id as string, 10) : null;

  return (
    <BaseLayout className="background-blue">
      <DocumentTitle>
        {params.id ? 'Edit Taxonomy Item' : 'Create Taxonomy Item'}
      </DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <TaxonomyForm id={id} key={id} />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensTaxonomyForm;
